/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ElectroSelectWithOther from '../../../../../../forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';

import styles from '../../../../ActionDrawer.module.scss';
import Form from '../../../../../../forms/_.extend';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

type TypeProps = {
  user: Object,
  form: Form,
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class DisableAccountForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { user, form, currentAccountDetails }: TypeProps = this.props;

    const userDetails: Array<Array> = [
      [
        t('general:trading_account'),
        `${currentAccountDetails.name} ${currentAccountDetails.account_no}`,
      ],
      [t('general:name'), `${user.first_name} ${user.last_name}`],
      [t('general:roles.labels.current_role'), t(`general:roles.${user.role_id}`)],
    ];

    const assignedToDetails: Array<Array> = [
      [t('general:asset_plural'), user.assets_count],
      [t('general:project_plural'), user.projects_count],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:users.labels.details')}
          >
            <ActionDrawerTable data={userDetails} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:labels.currently_assigned_to')}
          >
            <ActionDrawerTable data={assignedToDetails} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:trading_accounts.reasons.why_disable_access')}
          >
            <ElectroSelectWithOther
              field={form.$('disableUserAccessForm.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.disable_access')} />
      </React.Fragment>
    );
  }
}
